var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable, InjectionToken } from '@angular/core';
import { RouterPreloader } from '@angular/router';
import { PrefetchRegistry } from './prefetch-registry.service';
var ɵ0 = function (cb) {
    var start = Date.now();
    return setTimeout(function () {
        cb({
            didTimeout: false,
            timeRemaining: function () {
                return Math.max(0, 50 - (Date.now() - start));
            }
        });
    }, 1);
}, ɵ1 = function () { };
var requestIdleCallback = typeof window !== 'undefined'
    ? window.requestIdleCallback || ɵ0
    : ɵ1;
var ɵ2 = function () { };
var cancelIdleCallback = typeof window !== 'undefined' ? window.cancelIdleCallback || clearTimeout : ɵ2;
var observerSupported = function () {
    return typeof window !== 'undefined' ? !!window.IntersectionObserver : false;
};
var ɵ3 = observerSupported;
export var LinkHandler = new InjectionToken('LinkHandler');
var ObservableLinkHandler = /** @class */ (function () {
    function ObservableLinkHandler(loader, queue) {
        var _this = this;
        this.loader = loader;
        this.queue = queue;
        this.registerBuffer = [];
        this.unregisterBuffer = [];
        this.elementLink = new Map();
        this.observer = observerSupported()
            ? new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var link = entry.target;
                        _this.queue.add(_this.elementLink.get(link).urlTree);
                        _this.observer.unobserve(link);
                        requestIdleCallback(function () {
                            _this.loader.preload().subscribe(function () { return void 0; });
                        });
                    }
                });
            })
            : null;
    }
    ObservableLinkHandler.prototype.register = function (el) {
        var _this = this;
        this.elementLink.set(el.element, el);
        cancelIdleCallback(this.registerIdle);
        this.registerBuffer.push(el.element);
        this.registerIdle = requestIdleCallback(function () {
            _this.registerBuffer.forEach(function (e) { return _this.observer.observe(e); });
            _this.registerBuffer = [];
        });
    };
    ObservableLinkHandler.prototype.unregister = function (el) {
        var _this = this;
        this.elementLink.delete(el.element);
        cancelIdleCallback(this.unregisterIdle);
        this.unregisterBuffer.push(el.element);
        this.unregisterIdle = requestIdleCallback(function () {
            _this.unregisterBuffer.forEach(function (e) { return _this.observer.unobserve(e); });
            _this.unregisterBuffer = [];
        });
    };
    ObservableLinkHandler.prototype.supported = function () {
        return observerSupported();
    };
    ObservableLinkHandler = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [RouterPreloader, PrefetchRegistry])
    ], ObservableLinkHandler);
    return ObservableLinkHandler;
}());
export { ObservableLinkHandler };
var PreloadLinkHandler = /** @class */ (function () {
    function PreloadLinkHandler(loader, queue) {
        this.loader = loader;
        this.queue = queue;
    }
    PreloadLinkHandler.prototype.register = function (el) {
        var _this = this;
        this.queue.add(el.urlTree);
        requestIdleCallback(function () { return _this.loader.preload().subscribe(function () { return void 0; }); });
    };
    PreloadLinkHandler.prototype.unregister = function (_) { };
    PreloadLinkHandler.prototype.supported = function () {
        return true;
    };
    PreloadLinkHandler = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [RouterPreloader, PrefetchRegistry])
    ], PreloadLinkHandler);
    return PreloadLinkHandler;
}());
export { PreloadLinkHandler };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
//# sourceMappingURL=link-handler.service.js.map